import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as Urls from 'src/constants/EndpointUrls';
import { Pulldown } from 'jbc-front/components/icons';
import { getCurrentUserInfo } from 'src/reducers/users/currentUser';

import styles from '../Settings.scss';
import { withTranslation, useTranslation } from 'react-i18next';

const CoordinationServiceList = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <a href={Urls.COORDINATION_SERVICE_LIST}>
        <dl className={styles.definition}>
          <dt>
            <span className={styles.icon}>
              <Pulldown size={13} />
            </span>{t('features.Settings.Settings.service_link')}
          </dt>
          <dd>{t('features.Settings.Settings.Linkable_with_Jobcan_services')}</dd>
        </dl>
      </a>
    </React.Fragment>
  );
};

class Settings extends React.Component {
  state = {
    isModalOpen: false
  };

  render() {
    const { planType } = this.props;

    return (
      <React.Fragment>
        <div className={styles.main}>
          <section className={styles.section}>
            <h3 className={styles.category}>{this.props.t('features.Settings.Settings.general')}</h3>
            <ul className={styles.list}>
              <li>
                <a href={Urls.LIST_COMPANY_URL}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.office_information')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_office_information')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.CLIENT_PAYROLL_RULES_GROUP_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.EmployeePays.components.DownloadColumnDetail.salary_rules')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_salary_rule')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.CLIENT_ALLOWANCE_ITEMS}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.attendance_item')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_attendance_item')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.CLIENT_CSV_FORMATS_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.provision_and_deduction_list_format_setting')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_create_and_change_the_format_of_provision_and_deduction_list')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <CoordinationServiceList planType={planType} />
              </li>
              {/* @TODO: Hide Provident Fund for Vietnam */}
              {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
              {/*
              <li>
                <a href={Urls.CLIENT_PROVIDENT_FUND_EDIT}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.provident_fund_setting')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_provident_fund_setting')}</dd>
                  </dl>
                </a>
              </li>
              */}
            </ul>
          </section>
          <section className={styles.section}>
            <h3 className={styles.category}>{this.props.t('features.Settings.Settings.organization_management')}</h3>
            <ul className={styles.list}>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=groups`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Employees.components.BusinessInfoSection.group')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_group')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=occupations`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.occupation')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_occupation')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=positions`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Employees.components.BusinessInfoSection.position')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_occupation')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=employment_types`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.EmployeeBonus.components.EmployeeBonusTable.employment_type')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_employment_status')}</dd>
                  </dl>
                </a>
              </li>
            </ul>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(connect(state => ({
  planType: _.get(state, 'currentClient.item.data.planType'),
  currentUser: getCurrentUserInfo(state) || {}
}))(Settings));
